// src/components/modals/UnallowedLessonsModal.jsx
import React, { useEffect, useState } from "react";
import { Modal, Table, Spinner, Form } from "react-bootstrap";
import axios from "axios";
import { urlBase } from "../../utils/API";
import { useSelector } from "react-redux";
import { success, ErrorMsg } from "../../utils/Toast";
import { getLessonsByUserInClass } from "../../utils/class";

const UnallowedLessonsModal = ({ show, handleClose, Class, student }) => {
  const [lessonsList, setLessonsList] = useState([]);
  const [classUnallowed, setClassUnallowed] = useState([]);
  const [userUnallowed, setUserUnallowed] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingLesson, setLoadingLesson] = useState(null);

  const { user } = useSelector(({ loggedUser }) => ({
    user: loggedUser.user,
  }));

  useEffect(() => {
    if (show && Class && student) fetchLessons();
  }, [show, Class, student]);

  const fetchLessons = async () => {
    setLoading(true);
    try {
      const res = await getLessonsByUserInClass(
        Class?._id,
        student?._id,
        user?._id
      );

      const { lessons = [], unAllowedClassLessons = [], unallowedUserLessons = [] } =
        res?.data?.lessons || {};

      setLessonsList(lessons);
      setClassUnallowed(unAllowedClassLessons);
      setUserUnallowed(unallowedUserLessons);
    } catch (err) {
      console.error("Error fetching lessons:", err);
      ErrorMsg("Error fetching lessons");
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (lesson) => {
    const lessonId = lesson?._id;
    const classId = Class?._id;
    const studentId = student?._id;

    const isUserUnallowed = userUnallowed.includes(lessonId);
    const endpoint = isUserUnallowed
      ? `${urlBase}/api/remove-lesson-from-unallowed/${classId}/${lessonId}/${studentId}`
      : `${urlBase}/api/add-lesson-to-unallowed/${classId}/${lessonId}/${studentId}`;

    setLoadingLesson(lessonId);

    try {
      const res = await axios.post(endpoint);
      if (res?.data?.case) {
        success("تم تنفيذ العملية بنجاح");
        await fetchLessons(); // Refresh list to reflect changes
      } else {
        ErrorMsg("فشل في تحديث الدرس");
      }
    } catch (err) {
      console.error("Error updating lesson:", err);
      ErrorMsg("حدث خطأ أثناء التحديث");
    } finally {
      setLoadingLesson(null);
    }
  };

  const isLessonChecked = (id) =>
    classUnallowed.includes(id) || userUnallowed.includes(id);

  const isLessonDisabled = (id) => classUnallowed.includes(id);

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>إدارة الدروس غير المسموح بها للطالب {student?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : lessonsList.length > 0 ? (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>اسم الدرس</th>
                <th>رمز المادة</th>
                <th className="text-center">غير مسموح</th>
              </tr>
            </thead>
            <tbody>
              {lessonsList.map((lesson, idx) => (
                <tr key={lesson._id}>
                  <td>{idx + 1}</td>
                  <td>{lesson.name}</td>
                  <td>{lesson.materialCode}</td>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={isLessonChecked(lesson._id)}
                      disabled={isLessonDisabled(lesson._id)}
                      onChange={() => handleToggle(lesson)}
                      label={
                        loadingLesson === lesson._id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          ""
                        )
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p className="text-center text-muted">لا توجد دروس</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default UnallowedLessonsModal;
